import { TmRepositoryError } from '@/core/error/tmRepositoryError'

export class TmRepositoryNotRegisteredError extends TmRepositoryError {
  public readonly entity: string

  constructor(entity: string) {
    super(`Not found repository for ${entity}`)
    this.entity = entity
    this.setData({ entity })
  }
}
